import { render, staticRenderFns } from "./fdInventory27.vue?vue&type=template&id=4ee1950a"
import script from "./fdInventory27.vue?vue&type=script&lang=js"
export * from "./fdInventory27.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports